(function ($)
{
    let cBuildingListObjectCounter = 1;

    $.widget("ui.BuildingList",
        {
            options:
            {
                PageContentId: null,
                SubscribeUrl: null,
                BuildingResultSelector: '.fbcms_griditem.building',
                ResultListSelector: '.building_list',
                BuildingGallerySelector: '.building_gallery',
                MoreContainerSelector: '.building_list',
                LinkedBuildingClass: 'fbcms_linkedbuilding',
                BuildingInfoUrl: "/Core/Buildings/Block/",
                BuildingInfoLoadingTitle: 'Loading School Details',
                BuildingInfoSuccessTitle: 'School Details',
                BuildingInfoErrorTitle: 'Error Loading School Details',
                BuildingInfoLoadingContent: 'Loading School Details.',
                BuildingInfoErrorContent: 'Error loading School Details.'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _MyObjectNumber: null,

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);

                if (self.options.PageContentId === null)
                {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedBuildingClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.BuildingGallerySelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.MoreContainerSelector)
                )
                {
                    FBUtilities.LogMessage('BuildingList - required settings null or empty.');
                    return;
                }

                self._MyObjectNumber = cBuildingListObjectCounter++;

                const buildingListResultId = 'BuildingListResult' + self._MyObjectNumber;

                const jGallery = jElement.find(self.options.BuildingGallerySelector);
                jGallery.attr('role', 'region');
                jGallery.attr('aria-live', 'polite');
                jGallery.attr('id', buildingListResultId);

                self.SetupBuildingButtons();

                const buildingCardSelector = self.options.BuildingResultSelector + "[data-building-url]," + self.options.BuildingResultSelector + "[data-building-id]";

                jGallery.on(
                    'click',
                    buildingCardSelector,
                    function (aEvent)
                    {
                        aEvent.preventDefault();
                        const jElement = $(aEvent.target);
                        const jBuilding = jElement.parents(self.options.BuildingResultSelector);
                        const buildingId = jBuilding.data('building-id');
                        if (FBUtilities.IsParameterUndefinedOrNull(buildingId) === false)
                        {
                            self.SelectBuilding(buildingId, aEvent.target);
                            return false;
                        }

                        const url = jBuilding.data('building-url');
                        if (FBUtilities.IsParameterUndefinedOrNull(url) === false)
                        {
                            window.location = url;
                        }
                        return false;
                    }
                );

                jGallery.on(
                    'keypress',
                    buildingCardSelector,
                    function (aEvent)
                    {
                        if (aEvent.key !== "Enter" && aEvent.key !== " " && aEvent.key !== "Spacebar")
                        {
                            return
                        }

                        aEvent.preventDefault();
                        const jElement = $(this);
                        const buildingId = jElement.data('building-id');
                        if (FBUtilities.IsParameterUndefinedOrNull(buildingId) === false)
                        {
                            self.SelectBuilding(buildingId, this);
                            return false;
                        }

                        const url = jElement.data('building-url');
                        if (FBUtilities.IsParameterUndefinedOrNull(url) === false)
                        {
                            window.location = url;
                        }
                        return false;
                    }
                );

                const jControlledBuildingBlock = $('.fbcms_building_block');
                if (jControlledBuildingBlock.length > 0)
                {
                    jControlledBuildingBlock.attr('role', 'region');
                    jControlledBuildingBlock.attr('aria-live', 'polite');
                }

                self.SetupPagination();
            },

            SetupPagination: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const buildingListResultId = 'BuildingListResult' + self._MyObjectNumber;
                const jGalleryContainer = jElement.find(self.options.BuildingGallerySelector);
                const jMoreContainer = jGalleryContainer.find(self.options.MoreContainerSelector);

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Buildings/List/${self.options.PageContentId}/`,
                        LoadingTitle: "Schools",
                        NormalContainer: jGalleryContainer,
                        MoreContainer: jMoreContainer,
                        LiveRegionId: buildingListResultId
                    });
            },

            SetupBuildingButtons: function ()
            {
                const selector = `${this.options.BuildingResultSelector}[data-building-url],${this.options.BuildingResultSelector}[data-building-id]`;
                $(this.element).find(selector).css('cursor', 'pointer');
            },

            SelectBuilding: function (aBuildingId, aSelectionElement)
            {
                if (!FBUtilities.IsStringEmptyOrWhitespace(this.options.BuildingInfoUrl))
                {
                    new FBAjaxDialog().Start({
                        AjaxUrl: `${this.options.BuildingInfoUrl}${aBuildingId}`
                        , Data: { ParentContentId: this.options.PageContentId }
                        , ExtraDialogClasses: 'fbd_building'
                        , LoadingDialogTitle: this.options.BuildingInfoLoadingTitle
                        , SuccessDialogTitle: this.options.BuildingInfoSuccessTitle
                        , ErrorDialogTitle: this.options.BuildingInfoErrorTitle
                        , LoadingContent: this.options.BuildingInfoLoadingContent
                        , ErrorContent: this.options.BuildingInfoErrorContent
                        , SelectionElement: aSelectionElement
                    });
                }
            }
        });
})(jQuery);
